import { useTranslations } from 'next-intl';

type TFunction = ReturnType<typeof useTranslations>;

export function isDatetimePast(datetime: string | Date, useNowMinus30Minutes: boolean): boolean {
    const datetimeNow = new Date();
    if (useNowMinus30Minutes) {
        datetimeNow.setMinutes(datetimeNow.getMinutes() - 30);
    }
    const datetimeParam = new Date(datetime);
    return datetimeNow > datetimeParam;
}

/**
 * @param duration - Duration in minutes
 *
 * @returns {string} duration in format `DDh DDm` localized
 */
export function formatDuration(duration: number, t: TFunction): string {
    const hours = Math.floor(duration / 60);
    const hoursStr = hours > 0 ? t('common.time.hour-short', { hours }) : '';
    const minutes = duration % 60;
    const minutesStr = minutes > 0 ? t('common.time.minute-short', { minutes }) : '';

    return [hoursStr, minutesStr].filter(Boolean).join(' ');
}
